var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSingleNftIcon = function SvgSingleNftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "menu-item-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m32.33 21.025-6.94-8.9a3.674 3.674 0 0 0-5.368.075l-6.9 8.825a3.662 3.662 0 0 0-.588 1.981 3.71 3.71 0 0 0 .588 1.894l.072.084 6.891 8.9a3.6 3.6 0 0 0 2.637 1.128 3.674 3.674 0 0 0 2.713-1.2l6.891-8.824a3.6 3.6 0 0 0-.072-3.962Zm-1.885 2.569-6.807 8.668a1.333 1.333 0 0 1-1.7.084l-6.837-8.776a1.2 1.2 0 0 1-.168-.564 1.333 1.333 0 0 1 .12-.54l6.808-8.666a1.333 1.333 0 0 1 1.7-.084l6.759 8.74a2.225 2.225 0 0 1 .192.648 1.333 1.333 0 0 1-.12.492Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 20889",
    fill: "none",
    d: "M0 0h46v46H0z"
  })));
};
export default SvgSingleNftIcon;